import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UserService } from '../../services/user/user.service';
import { ChatService } from '../../services/chat/chat.service';
import { StudioSidebarService } from '../../services/studio-sidebar/studio-sidebar.service';

@Component({
  selector: 'sc-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
  @Input() sidebarIndex: number;
  @Input() chatGroupID: string = null;
  @Output() closeSidebar = new EventEmitter();

  constructor(
    public userService: UserService,
    public chatService: ChatService,
    private studioSidebarService: StudioSidebarService
  ) {}

  ngOnInit() {}

  /**
   * Resets the active chat group
   * Hides the group and returns to groups
   */
  async back() {
    this.studioSidebarService.toggleSidebar(undefined, true, this.sidebarIndex, { chatGroupID: null });
  }

  selectChatGroup(chatGroupID: string) {
    this.studioSidebarService.toggleSidebar(undefined, true, this.sidebarIndex, { chatGroupID });
  }
}
